import { OrderReceiptRecord } from '@navio/nsdk';

export function downloadOrderReceipt(receipts: OrderReceiptRecord[]) {
  const sortedReceipts = receipts.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
  const latestReceipt = sortedReceipts[0] as OrderReceiptRecord;
  const a = document.createElement('a');
  a.href = latestReceipt.url ?? '#';
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  a.click();
}
